import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeading = ({ eyebrow, title, align = "left" }) => (
  <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
    <Reveal>
      <span className="font-mono text-xs uppercase tracking-[0.28em] text-[var(--gold)]">
        {eyebrow}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-[var(--text)]">
        {title}
      </h2>
    </Reveal>
  </div>
);
